<div [ngClass]="isSingleBreadcrumb ? 'breadcrumb-cursor-default' : ''" class="breadcrumb-main">
    <div [ngClass]="isSingleBreadcrumb ? 'breadcrumb-cursor-default' : ''" class="breadcrumb-selected">
        <div [ngClass]="isSingleBreadcrumb ? 'breadcrumb-cursor-default' : ''" class="member-icon"></div>
        <div [ngClass]="isSingleBreadcrumb ? 'breadcrumb-cursor-default' : ''" id="breadcrumb-person" class="breadcrumb-selected-name">{{breadCrumbList[0]?.DisplayName}}</div>
        <div [ngClass]="isSingleBreadcrumb ? 'breadcrumb-cursor-default' : ''" class="dropdown-arrow" *ngIf="(breadCrumbList?.length > 1)"></div>
    </div>
    <div class="breadcrumb-list" *ngIf="(breadCrumbList?.length > 1)">
        <div class="breadcrumb-list-item" *ngFor="let crumb of breadCrumbList.slice(1)" (click)="changeRootPerson(crumb)">
            <div class="member-icon"></div>
            <div class="breadcrumb-list-item-name">{{crumb.DisplayName?.trim()}}</div>
        </div>
    </div>
</div>